// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "tour" + "." + "0be14fc8" + ".chunk.css";
};